var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33694_4628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "#D9D9D9",
    stroke: "#0E72ED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33694_4628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1498 10.3498V9.6498H20.8498V10.3498H16.1498ZM8.99981 11.1998C8.25731 11.1998 7.62172 10.9355 7.09306 10.4068C6.56422 9.87797 6.29981 9.2423 6.29981 8.4998C6.29981 7.7573 6.56422 7.12164 7.09306 6.5928C7.62172 6.06414 8.25731 5.7998 8.99981 5.7998C9.74231 5.7998 10.3779 6.06414 10.9066 6.5928C11.4354 7.12164 11.6998 7.7573 11.6998 8.4998C11.6998 9.2423 11.4354 9.87797 10.9066 10.4068C10.3779 10.9355 9.74231 11.1998 8.99981 11.1998ZM2.2998 18.1998V16.8998C2.2998 16.5331 2.4123 16.1873 2.6373 15.8623C2.8623 15.5373 3.16647 15.2831 3.5498 15.0998C4.46647 14.6665 5.37897 14.3415 6.28731 14.1248C7.19564 13.9081 8.09981 13.7998 8.99981 13.7998C9.89981 13.7998 10.804 13.9081 11.7123 14.1248C12.6206 14.3415 13.5331 14.6665 14.4498 15.0998C14.8331 15.2831 15.1373 15.5373 15.3623 15.8623C15.5873 16.1873 15.6998 16.5331 15.6998 16.8998V18.1998H2.2998ZM2.9998 17.4998H14.9998V16.8998C14.9998 16.6665 14.9206 16.4456 14.7623 16.2373C14.604 16.029 14.3831 15.8498 14.0998 15.6998C13.2998 15.3165 12.4691 15.0206 11.6076 14.8123C10.7462 14.604 9.87697 14.4998 8.99981 14.4998C8.12264 14.4998 7.25339 14.604 6.39206 14.8123C5.53056 15.0206 4.6998 15.3165 3.8998 15.6998C3.61647 15.8498 3.39564 16.029 3.2373 16.2373C3.07897 16.4456 2.9998 16.6665 2.9998 16.8998V17.4998ZM8.99981 10.4998C9.54981 10.4998 10.0206 10.304 10.4123 9.9123C10.804 9.52064 10.9998 9.0498 10.9998 8.4998C10.9998 7.9498 10.804 7.47897 10.4123 7.0873C10.0206 6.69564 9.54981 6.4998 8.99981 6.4998C8.44981 6.4998 7.97897 6.69564 7.58731 7.0873C7.19564 7.47897 6.9998 7.9498 6.9998 8.4998C6.9998 9.0498 7.19564 9.52064 7.58731 9.9123C7.97897 10.304 8.44981 10.4998 8.99981 10.4998Z",
    fill: "#0E72ED",
    stroke: "#0E72ED",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRemove);
export default __webpack_public_path__ + "static/media/person_remove.b3f54a87ae6dc1f1d03546c36fa95e0e.svg";
export { ForwardRef as ReactComponent };